import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaCheckCircle, FaWhatsapp } from "react-icons/fa";
import HeaderSection from "../../components/HeaderSection";
import { API_URL } from "../../url/api";

interface FormData {
  name: string;
  email: string;
  message: string;
  phone: string;
  consultation: boolean;
  assesment: boolean;
  is_email_send: boolean;
}

const ContactUsPage: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: "",
    email: "",
    message: "",
    phone: "",
    consultation: false,
    assesment: false,
    is_email_send: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | any>
  ) => {
    const { id, value, type } = e.target as HTMLInputElement;
    const checked = e.target.type === "checkbox" ? e.target?.checked : false;
    setFormData((prevData) => ({
      ...prevData,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post(API_URL + "contact-details/", formData);
      console.log("Form submitted successfully:", response.data);
      setFormData({
        name: "",
        email: "",
        message: "",
        phone: "",
        consultation: false,
        assesment: false,
        is_email_send: false,
      });
      setSuccessMessage(
        "We will contact you soon via Email / Phone. Thanks for your interest!"
      );
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // useEffect(() => {
  //   const userId = localStorage.getItem("userId");

  //   if (userId) {
  //     window.location.href = "/dashboard";
  //   }
  // }, []);

  return (
    <>
      <HeaderSection />
      <div className="flex w-full justify-center mt-8 px-4">
        <div className="w-full bg-white shadow-md rounded-lg px-8 pt-6  pb-8 mb-4 max-w-6xl">
          <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
          {successMessage ? (
            <div
              className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4"
              role="alert"
            >
              <div className="flex items-center">
                <div className="py-1">
                  <FaCheckCircle className="fill-current h-6 w-6 text-green-500 mr-4" />
                </div>
                <div>
                  <p className="font-bold">{successMessage}</p>
                </div>
              </div>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="name"
                >
                  Name
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="name"
                  type="text"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="email"
                >
                  Email
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="email"
                  type="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="message"
                >
                  Message
                </label>
                <textarea
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="message"
                  placeholder="Enter your message"
                  rows={4}
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div className="mb-4">
                <label
                  className="block text-gray-700 text-sm font-bold mb-2"
                  htmlFor="phone"
                >
                  Phone
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="phone"
                  type="tel"
                  placeholder="Enter your phone number"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-4">
                <input
                  className="mr-2 leading-tight w-9"
                  id="consultation"
                  type="checkbox"
                  size={30}
                  checked={formData.consultation}
                  onChange={handleChange}
                />
                <label
                  className="text-gray-700 text-sm font-bold"
                  htmlFor="consultation"
                >
                  Book a free consultation
                </label>
              </div>

              <div className="mb-4">
                <input
                  className="mr-2 leading-tight w-9"
                  id="assesment"
                  type="checkbox"
                  size={30}
                  checked={formData.assesment}
                  onChange={handleChange}
                />
                <label
                  className="text-gray-700 text-sm font-bold"
                  htmlFor="assesment"
                >
                  Get an assessment
                </label>
              </div>

              <div className="flex items-center justify-between">
                <button
                  className="bg-primary hover:bg-primary text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          )}

          <>
          <div className="bg-white pt-4 rounded-lg">
      <p className="text-gray-700 mb-6">
        To get in touch with us, you have several convenient options:
      </p>
      <ul className="space-y-4">
        <li className="flex items-center space-x-2">
          <FaWhatsapp size={24}color="green" />
          <span>
            <strong>WhatsApp:</strong>{' '}
            <a 
              href={`https://wa.me/${916374480026}?text=Hi`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 underline">
              Send us a message
            </a>
          </span>
        </li>
        <li className="flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-blue-500 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
          <span>
            <strong>Email:</strong> Reach out to us at <a href="mailto:contact@shvesa.com" className="text-blue-500 underline">
            contact@shvesa.com
            </a>
          </span>
        </li>
        <li className="flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-red-500 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
          <span>
            <strong>Live Chat:</strong> Click the chat window on our website to
            instantly connect with one of our friendly representatives who is
            standing by ready to assist you. <a href="www.shvesa.com" className="text-blue-500 underline">click here</a>
          </span>
        </li>
      </ul>
      <p className="text-gray-700 mt-6">
        We look forward to hearing from you and providing the help you need!
      </p>
    </div>
    </>
        </div>
      </div>
    </>
  );
};

export default ContactUsPage;
